import { render } from "./AccountSwitcher.vue?vue&type=template&id=725539a8&scoped=true"
import script from "./AccountSwitcher.vue?vue&type=script&lang=js"
export * from "./AccountSwitcher.vue?vue&type=script&lang=js"

import "./AccountSwitcher.vue?vue&type=style&index=0&id=725539a8&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725539a8"]])

export default __exports__